import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-navy" data-id="element-169" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-170" data-mp="3b1469ghotr6w">
        <h2 id="testimonios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-171" data-mp="3ayqbl8qx6gzv">
          Lo que dicen <span className="text-ice" data-id="element-172" data-mp="31yl6j5977uov">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-173" data-mp="2x1kywpwpajvn">
          De no saber por dónde comenzar a comprender cómo funciona un sistema
          de aire acondicionado automotriz.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-174" data-mp="v8ndvg960vl9">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-ice bg-white p-2.5 text-left text-navy ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-175" data-mp="qb51ffvxvy8i" data-mpi={i}>
              <div className="flex items-center justify-between gap-2" data-id="element-176" data-mp="7a4xaympzpnf">
                <span className="font-sub text-xs font-semibold text-cta" data-id="element-177" data-mp="c7dfv0bs5vp7">
                  TESTIMONIO {i + 1}
                </span>
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-178" data-mp="14vj2xtqb3ws7">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-amber-400 text-amber-400" data-id="element-179" data-mp="q5lbn4x2yqys" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-180" data-mp="v3d1zui2u50v">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-181" data-mp="1nma6genm4syo">
                <p className="font-sub text-sm font-semibold text-brand" data-id="element-182" data-mp="1no3ik9gzw5e2">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-slate-600" data-id="element-183" data-mp="1siwdchennu79">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-184" data-mp="1ji7zpnt6bvuw">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-185" data-mp="1ejoddmao4i20">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}